import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import { Order } from '../Order'
import { Field, ID, InputType, ObjectType } from 'type-graphql'

/**
 * Args for creating a sales order from a conversation — the operator picks the conversation
 * and nothing else; the customer is derived from it.
 */
@InputType()
export class CreateOrderFromConversationArgs extends ActionArgs {
  /** Conversation (Chat) id to create the order from. Must carry no document link yet. */
  @Field(() => ID)
  chatId: string
}

/**
 * The created order plus the outcome of the sign-in credential mail. Only a customer still flagged
 * unverified is mailed credentials: `credentialsMailSent` is `true` when that mail went out and
 * `false` when the send was attempted and failed. It is unset (`null` over GraphQL) when no send
 * was attempted, so a caller surfaces a failure on `false` alone.
 */
@ObjectType()
export class CreateOrderFromConversationResult {
  @Field(() => Order)
  order: Order

  @Field(() => Boolean, { nullable: true })
  credentialsMailSent?: boolean
}

/**
 * Interface for the CreateOrderFromConversation action.
 * Returns the created order and, when a credential mail was attempted, whether it was sent.
 */
export interface ICreateOrderFromConversation extends IAction<
  CreateOrderFromConversationResult,
  CreateOrderFromConversationArgs
> {}
